// extracted by mini-css-extract-plugin
module.exports = {"tilemanager-main":"tilemanager-main__2kT32","card-cell":"card-cell__3qBHv"};